/**
 * Copyright 2026 Perform Content Services Limited. Confidential and Proprietary. All Rights Reserved.
 */

import PropTypes from 'prop-types';
import styles from './controls/styles/controls.css';

export const PlaybackControls = ({
  showControls,
  showNativeControls,
  areControlsShown,
  leftColumnControls = [],
  rightColumnControls = [],
  floatingControls = [],
  seekbarControl
}) => {
  if (!Array.isArray(leftColumnControls) || !Array.isArray(rightColumnControls) || !Array.isArray(floatingControls)) {
    return null;
  }

  return <div id="videoControls" className={`${styles.videoControls} ${areControlsShown ? styles.show : styles.hide}
    ${showNativeControls ? styles.hideDisplay : styles.overlayBottom}`} onMouseMove={showControls} onTouchStart={showControls}
  >
    {floatingControls.length > 0 && floatingControls}
    <div className={styles.bar}>
      {seekbarControl}
      <div className={`${styles.videoColLeft} ${styles.videoColCell}`}>
        {leftColumnControls}
      </div>
      <div className={`${styles.videoColRight} ${styles.videoColCell}`}>
        {rightColumnControls}
      </div>
    </div>
  </div>;
};

PlaybackControls.propTypes = {
  config: PropTypes.object,
  areControlsShown: PropTypes.bool.isRequired,
  floatingControls: PropTypes.array.isRequired,
  leftColumnControls: PropTypes.array.isRequired,
  rightColumnControls: PropTypes.array.isRequired,
  showControls: PropTypes.func.isRequired,
  showNativeControls: PropTypes.bool,
  seekbarControl: PropTypes.node
};

PlaybackControls.defaultProps = {
  config: {},
  leftColumnControls: [],
  rightColumnControls: [],
  floatingControls: [],
  showNativeControls: false,
  seekbarControl: null
};